import axios from 'axios';
import { processErrorResponse, processSuccessResponse } from './process-response';

axios.defaults.withCredentials = true;

function setDefaultAuthHeader(authToken) {
  axios.defaults.headers.common.Authorization = `bearer ${authToken}`;
}

function setDefaultApiUrl(baseURL) {
  axios.defaults.baseURL = baseURL;
}

function get(url, params = {}) {
  return axios.get(url, { params }).then(processSuccessResponse).catch(processErrorResponse);
}

function post(url, data = {}) {
  return axios.post(url, data).then(processSuccessResponse).catch(processErrorResponse);
}

function postMultipart(url, data = {}, config = {}) {
  const formData = new FormData();
  Object.keys(data).forEach((key) => formData.append(key, data[key]));
  return axios
    .post(url, formData, {
      ...config,
      headers: { ...config.headers, 'Content-Type': 'multipart/form-data' },
    })
    .then(processSuccessResponse)
    .catch(processErrorResponse);
}

function put(url, data = {}) {
  return axios.put(url, data).then(processSuccessResponse).catch(processErrorResponse);
}

function httpDelete(url) {
  return axios.delete(url).then(processSuccessResponse).catch(processErrorResponse);
}

export default {
  delete: httpDelete,
  get,
  post,
  postMultipart,
  put,
  setDefaultAuthHeader,
  setDefaultApiUrl,
};
